import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=5656ff83&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=js"
export * from "./GroupMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656ff83",
  null
  
)

export default component.exports